import './App.css';
import AnalyticsConsentBanner from '@components/AnalyticsConsentBanner';
import { AnalyticsConsentUiProvider } from '@/context/AnalyticsConsentUiContext';
import HomePage from '@pages/HomePage';

const BUY_ME_A_COFFEE_URL = 'https://www.buymeacoffee.com/sramuschkat';

function App() {
  return (
    <AnalyticsConsentUiProvider>
      <div className="app-page-gutter">
        <div className="portfolio-wizard-bmc-slot">
          <a
            className="portfolio-wizard-bmc"
            href={BUY_ME_A_COFFEE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span aria-hidden="true">☕</span>
            <span>Buy me a coffee</span>
          </a>
        </div>
        <HomePage />
        <AnalyticsConsentBanner />
      </div>
    </AnalyticsConsentUiProvider>
  );
}

export default App;